import { searchBotAPI, invalidMessage, noRelevanceApi } from '../Services/searchRequest'
import { isValidMessage } from '../Utils/verificatorMessages'

class MessageParser {
  constructor(message, actionProvider) {
    this.message = message.toLowerCase()
    this.actionProvider = actionProvider
  }

  async parseMessage() {
    try {
      const invalid = await invalidMessage()
      if (!isValidMessage(this.message)) {
        this.actionProvider.sendCustomMessage('StaticMessages', { text: invalid })
        return
      }
      const search = await searchBotAPI(this.message)
      console.log("search d", search)

      const answerFaq = search.answerFaq ?? {}
      const hasNewsTag = search?.answerFaq?.tag === "news"
      const hasTagValueThanks = search?.answerFaq?.tag === "Thanks"
      const hasTagValueBot = search?.answerFaq?.tag || search?.faq?.tag === "Bot"

      if ((!search.answerFaq || Object.keys(search.answerFaq).length === 0) && (!search.documents || search.documents.length === 0)){
        const noRelevance = await noRelevanceApi(this.message)
        this.actionProvider.sendCustomMessage('StaticMessages', { text: noRelevance })
        return
      }
      if (hasNewsTag) {
        this.actionProvider.sendCustomMessage('SearchComponent', search)
        return
      }
      if (hasTagValueThanks) {
        this.actionProvider.sendCustomMessage('StaticMessages', { text: answerFaq.answer })
        return
      }

      const componentName = hasTagValueBot ? 'BotStoryMessage' : 'SearchComponent'
      this.actionProvider.sendCustomMessage(componentName, search)

    } catch (error) {
      console.error("Search API Error:", error)
      this.actionProvider.sendBotMessage("Ops, não estou conseguindo responder a sua pergunta, tente novamente mais tarde!")
    }
  }
}

export default MessageParser